import { render, staticRenderFns } from "./LogoCreate.vue?vue&type=template&id=45a88cd0"
import script from "./LogoCreate.vue?vue&type=script&lang=ts"
export * from "./LogoCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports